<template>
  <div class="collapse" id="anchorNick">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['global'],
      }"
      @click="configMainShow['global'] = !configMainShow['global']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>其他配置</span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['welcome'].timeRemaining)
          ? shoWDialogBuy(
              featureList['welcome']['productKey'],
              '基础包',
              'welcome'
            )
          : featureList['welcome'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : ''
      "
      :class="{
        'no-buy': isNaN(featureList['welcome'].timeRemaining),
        expired: featureList['welcome'].timeRemaining <= 0,
      }"
    >
      <el-row>
        <el-col :span="5">主播昵称</el-col>
        <el-col :span="19">
          <el-input
            class="anchor-nickname"
            size="medium"
            v-model.trim="configure.global.anchorNick"
            placeholder="请输入主播昵称"
          ></el-input>
          的直播间
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">词库风格</el-col>
        <el-col :span="19">
          <el-radio-group
            v-model="configure.global.thesaurus"
            size="small"
            @change="thesaurusChange"
          >
            <el-radio-button label="man">朴素词库</el-radio-button>
            <el-radio-button label="girl">花式词库</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="5">昵称修饰词</el-col>
        <el-col :span="19">
          <div class="block-tag">
            给粉丝昵称智能添加前缀、后缀等修饰词，增加变化。
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.global.citySwitch"></el-switch
            >添加「城市」（欢迎 <span class="yellow">南宁</span>小虎弟）
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.global.closeSwitch"></el-switch
            >添加「亲近词」（欢迎 <span class="yellow">我家</span>小虎弟）
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.global.rankSwitch"></el-switch
            >添加「榜单尊称」（欢迎 <span class="yellow">榜一</span>小虎弟）
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.global.nobleSwitch"></el-switch
            >添加「贵族尊称」（欢迎小虎弟 <span class="yellow">骑士</span>）
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.global.sexSwitch"></el-switch
            >添加「性别尊称」（欢迎小虎弟 <span class="yellow">小哥哥</span>）
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">句尾表情</el-col>
        <el-col :span="19">
          <div class="block-tag">
            不足30字的句子，会在句尾随机添加表情。
          </div>
          <div class="row-padding">
            <el-input-number
              v-model="configure.global.emojiChance"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :max="100"
              size="mini"
              :precision="0"
            ></el-input-number
            >%出现概率
          </div>
          <div class="row-padding">
            <p>选择希望出现的表情：</p>
            <div class="emot-panel">
              <ul class="emot-list">
                <li
                  v-for="item in emotList"
                  :key="item.value"
                  class="emot-item"
                >
                  <a :title="item.value">
                    <i class="emot" :class="item.class"></i>
                    <input
                      type="checkbox"
                      :checked="
                        configure.global.emotList.indexOf(item.value) != -1
                          ? true
                          : false
                      "
                      @change="emotListChange"
                      :value="item.value"
                    />
                    <i class="fa-check-circle"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">自动续牌</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <span
              @click.capture="
                !configure.autoFeed.enable ? toggleAutoEnable() : ''
              "
            >
              <el-switch
                v-model="configure.autoFeed.enable"
                :disabled="!configure.autoFeed.enable"
              ></el-switch> </span
            >自动送背包里的虎粮
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">自动抢宝箱</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <span
              @click.capture="
                !configure.global.enableBox ? toggleBoxEnable() : ''
              "
            >
              <el-switch
                v-model="configure.global.enableBox"
                :disabled="!configure.global.enableBox"
              ></el-switch> </span
            >自动抢宝箱
          </div>
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('其他配置', 'global')"
          >「其他配置」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getFeatureWords } from "@/api/index";
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      thesaurusWords: null,
      emotList: require("@/assets/js/emotList.json"),
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
  },
  mounted() {},
  methods: {
    thesaurusChange(val) {
      if (!this.thesaurusWords) {
        getFeatureWords({ notify: false }).then((res) => {
          if (res.code === 0) {
            this.thesaurusWords = res.data.words;
            this.changeThesaurusConfirm(val);
          }
        });
      } else {
        this.changeThesaurusConfirm(val);
      }
    },
    changeThesaurusConfirm(val) {
      this.$confirm(
        `即将载入${
          val == "girl" ? "花式词库" : "朴素词库"
        }，如果有自己配置过的句子会被覆盖`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then((action) => {
          if (action == "confirm") {
            if (val === "girl") {
              for (let item in this.thesaurusWords.female) {
                for (let subitem in this.thesaurusWords.female[item]) {
                  this.configure[item][subitem].tpl = JSON.parse(
                    JSON.stringify(
                      this.thesaurusWords.female[item][subitem].tpl
                    )
                  );
                }
              }
            }
            if (val === "man") {
              for (let item in this.thesaurusWords.male) {
                for (let subitem in this.thesaurusWords.male[item]) {
                  this.configure[item][subitem].tpl = JSON.parse(
                    JSON.stringify(this.thesaurusWords.male[item][subitem].tpl)
                  );
                }
              }
              this.configure.giftTks.giftTksPreWords.preEnable = false;
            }
            this.configure.global.thesaurus = val;
          }
        })
        .catch((error) => {
          if (error == "cancel") {
            if (val === "girl") {
              this.configure.global.thesaurus = "man";
            } else {
              this.configure.global.thesaurus = "girl";
            }
            setTimeout(() => {
              this.savechange();
            }, 0);
          }
        });
    },
    emotListChange(e) {
      if (e.target.checked) {
        if (
          this.configure.global.emotList.indexOf(e.target.defaultValue) == -1
        ) {
          this.configure.global.emotList.push(e.target.defaultValue);
        }
      } else {
        if (
          this.configure.global.emotList.indexOf(e.target.defaultValue) != -1
        ) {
          this.configure.global.emotList.splice(
            this.configure.global.emotList.indexOf(e.target.defaultValue),
            1
          );
        }
      }
    },
    toggleAutoEnable() {
      //切换自动续牌开关
      if (!this.configure.global.liveRoomUrl) {
        this.$message.warning("请输入要服务的直播间地址");
        this.$emit("roomUrlInputFocus");
        return;
      }
      if (!this.configure.autoFeed.enable) {
        this.$confirm(`确认打开自动续牌功能?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.configure.autoFeed.enable = true;
          })
          .catch(() => {});
      }
    },
    toggleBoxEnable() {
      //切换自动抢宝箱
      if (!this.configure.global.liveRoomUrl) {
        this.$message.warning("请输入要服务的直播间地址");
        this.$emit("roomUrlInputFocus");
        return;
      }
      if (!this.configure.global.enableBox) {
        this.$confirm(`确认打开自动抢宝箱功能?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.configure.global.enableBox = true;
          })
          .catch(() => {});
      }
    },
  },
};
</script>
